/**
 * 
 * @ OCI VALIDATOR Selected Function
 * @ Author: JOGA, 26.11.2015
 *
 */

if (typeof $ != 'undefined') //fallback for when jquery not included. 
$(function(){ 
    $('#oci_validator_function_type').on('change',function() {
        //alert($('#oci_validator_function_type').val());
        if ($(this).val()==="VALIDATE") {
            //console.log("Handler for detail function called");
            $("#id_item_product_id").show();
            $("#id_item_oci_quantity").show();
            $("#id_item_search_string").hide();
        } else if($(this).val()==="BACKGROUND_SEARCH") {
            //console.log("Handler for search function called");
            $("#id_item_search_string").show();
            $("#id_item_product_id").hide();
            $("#id_item_oci_quantity").hide();
        } else if($(this).val()==="DETAIL") {
            //console.log("Handler for detail function called");
            $("#id_item_product_id").show();
            $("#id_item_oci_quantity").hide();
            $("#id_item_search_string").hide();            
        }
    })
});


function showAppropriateOCIValidatorFields() { 
    
    var selected_oci_function = $('#oci_validator_function_type').val();
    if (selected_oci_function === "VALIDATE") {
        $("#id_item_product_id").show();
        $("#id_item_oci_quantity").show();
        $("#id_item_search_string").hide();
    
    } else if (selected_oci_function === "BACKGROUND_SEARCH") {
        $("#id_item_search_string").show();
        $("#id_item_product_id").hide();
        $("#id_item_oci_quantity").hide();
    
    } else if (selected_oci_function === "DETAIL") {
        $("#id_item_product_id").show();
        $("#id_item_oci_quantity").hide();
        $("#id_item_search_string").hide();
    
    } else {
        $("#id_item_product_id").hide();
        $("#id_item_oci_quantity").hide();
        $("#id_item_search_string").hide();
    }
}

/**
 *  @ OCI VALIDATOR SubmitForm
 * @Author: JOGA, 27.11.2015
 */
function SubmitOciValidator(){
    
    var oci_url = $('#oci_url').val();
    var selected_oci_function = $('#oci_validator_function_type').val();
    var product_id = $('#product_id').val();
    var oci_quantity = $('#oci_quantity').val();
    var search_string = $('#search_string').val();  
    
    var params = {};                
    
    var responseData = "";
    
    var sURL = oci_url+"&FUNCTION="+selected_oci_function+"&PRODUCTID="+product_id+"&QUANTITY="+oci_quantity;
    
    if (document.oci_validator_form.submit) {
        if (selected_oci_function === 'DETAIL') { // DETAIL
            document.oci_validator_form.product_id.value = product_id;            
            
            params.FUNCTION = selected_oci_function;
            params.PRODUCTID = product_id;
            
        } else if (selected_oci_function === 'VALIDATE') { // product_id
            document.oci_validator_form.product_id.value = product_id;
            if (!oci_quantity || oci_quantity == 0 ) {
                oci_quantity = 1;
            }
            document.oci_validator_form.oci_quantity.value = oci_quantity;
            
            params.FUNCTION = selected_oci_function;
            params.PRODUCTID = product_id;
            params.QUANTITY = oci_quantity;            
            
        } else { // SEARCH
            document.oci_validator_form.search_string.value = search_string;
        }                            
        
        // var popup = window.open(oci_url, 'ociCallWindow', 'width=800,height=600,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=yes,menubar=no,copyhistory=no');                
        // popup.focus();
                
        ajaxHandler = $.ajax({
            beforeSend: function(xhrObj){
                xhrObj.setRequestHeader('Content-Type: text/plain');
                xhrObj.setRequestHeader('Access-Control-Expose-Headers: Location');                
//                xhrObj.setRequestHeader('Access-Control-Allow-Origin:  *');
//                xhrObj.setRequestHeader('Access-Control-Allow-Methods: DELETE, HEAD, GET, OPTIONS, POST, PUT');
//                xhrObj.setRequestHeader('Access-Control-Allow-Headers: Content-Type, Content-Range, Content-Disposition, Content-Description');
//                xhrObj.setRequestHeader('Access-Control-Max-Age: 1728000');
            },
            type: "POST",
            url: oci_url,                 
            processData: true,
            crossDomain: true,
            data: params,
            contentType: 'application/json; charset=utf-8; text/html',
            dataType: 'jsonp',
            cache: false,
            async: false,
            jsonpCallback: function(json) {         
                console.log(json);
                //alert("JSON format" + JSON.stringify('{"result":"'+json+'"}'));
                //$('#resultForm').submit();
            },
            success: function (content) {                
                alert(content);
            },
            statusCode: {
                404: function () {
                    alert("Error on ajax: Not found: '" + oci_url + "'");
                }
            }
        });
        
        console.log("The response from the oci_url is: " + responseData);
        
        document.oci_validator_form.responseData.value = responseData;
        document.oci_validator_form.submit();
        
    }
}